import { render, staticRenderFns } from "./PlayAudioModal.vue?vue&type=template&id=88355608&scoped=true&"
import script from "./PlayAudioModal.vue?vue&type=script&lang=js&"
export * from "./PlayAudioModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88355608",
  null
  
)

export default component.exports